import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'checkout-retailer_initiate_checkout-click';

/**
 * Track when retailer user initiate checkout
 */
export function trackCheckoutRetailerInitiateCheckoutClick(
  currency: string,
  cartValue2: string,
  retailer_token3: string,
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'InitiateCheckout',
    googleTagManagerEvent: 'InitiateCheckout',
    pixelCustomDataParams,
    parameters: { currency, cartValue2, retailer_token3 },
  });
}
